const randomRGBA = () => {
  const o = Math.round,
    r = Math.random,
    s = 255;
  return [o(r() * s), o(r() * s), o(r() * s), r().toFixed(1)];
};
export default randomRGBA;
